import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form
} from 'reactstrap';
import moment from 'moment';

import { IMAGE } from "common-import/constants";
import { inject, observer } from "mobx-react"
import { makeInput } from "common-import/custom";
import {Link} from "react-router-dom";

@inject("contactStore", "companyInfoStore", "userStore", "contractorStore") @observer
class ContactList extends Component {

  constructor(props) {
    super(props);
  }

  state = {
    keyword: "",
    message: "",
    list: [],
    listCompany: [],
    contactList: []
  };

  async componentDidMount() {
    // const { userStore, contactStore } = this.props;
    // await userStore.onReady();
    // await contactStore.getContactList("798233922322");
  }

  renderRow = (data, index) => {
    return (
      <tr key={"listuser"+index}>
        <td className="text-center">
          <div className="avatar">
            <img src={data.avatar || IMAGE} className="img-avatar" alt="admin@bootstrapmaster.com"/>
            {/* <span className="avatar-status badge-success"></span> */}
          </div>
        </td>
        <td>
          <Link to={`/contacts/${data.id}?name=${data.name}`}>
            <div>{data.name}</div>
            <div className="small text-muted">
              <span>Email</span>: {data.email}
              <br/>
              <span>Id: </span> {data.id}
            </div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.tel}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.jobTitle}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="small text-muted">{data.companyTaxCode}</div>
        </td>
      </tr>
      
    )
  };

  render() {
    const { list, message, listCompany, contactList } = this.state;
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"> </i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Get contact list with company's name or company tax code" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>

        <Form onSubmit={this.searchOldId}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.searchOldId}><i className="fa fa-search"> </i> Search by Old ID</Button>
                </InputGroupAddon>
                {makeInput(this, "oldId")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Type old id" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>

        <Row>
          <Col xs="12" sm="12">
            {message !== "" && <p style={{ marginBottom: 20, testAlign: "center", display: "block", fontWeight: "bold", color: "green" }}>{message}</p>}
            {this.renderCompanyList()}
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th className="text-center"><i className="icon-people"> </i></th>
                  <th>Contact</th>
                  <th>Telephone</th>
                  <th>Job title</th>
                  <th>Company Code</th>
                </tr>
              </thead>
              <tbody>
                {contactList.map((val, index) => this.renderRow({
                      id: val.id,
                      name: val.name,
                      email: val.email,
                      tel: val.phone,
                      jobTitle: val.position,
                      companyTaxCode: val.companyTaxCode,
                      avatar: val.avatar
                    }, index))
                }
              </tbody>
            </Table>
          </Col>
        </Row>

      </div>
    );
  }

  renderCompanyList = () => {
    const { listCompany } = this.state;
    return (
      <div style={{ maxHeight: 100, overflow: "auto", marginBottom: 20 }}>
        {listCompany.map((val, index) => (
          <p className="cursor hover-underline" key={"comp"+index} onClick={()=>this.findContact(val)}>{val.name}</p>
        ))}
      </div>
    )
  };

  search = async (e) => {
    !!e && e.preventDefault();
    this.setState({ message: "Searching..." });
    const { contractorStore, companyInfoStore } = this.props;
    const { keyword } = this.state;
    const isNumber = !isNaN(keyword);
    const findObject = isNumber ? { taxCode: keyword } : { name : keyword };
    let companyResult = await contractorStore.simpleSearch(findObject);
    if (!!companyResult.error) {
      this.setState({ message: "", companyList: companyResult.data });
      return window.toast.error("Error occurred, please try again " + JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: companyResult.data, message: companyResult.data.length > 0 ? "" : "Company not found." })
  };

  searchOldId = async (e) => {
    !!e && e.preventDefault();
    this.setState({ message: "Searching..." });
    const { contractorStore } = this.props;
    const { oldId } = this.state;
    let companyResult = await contractorStore.searchByOldId(oldId);
    if (!!companyResult.error) {
      this.setState({ message: "", companyList: companyResult.data });
      return window.toast.error("Error occurred, please try again " + JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: [companyResult.data], message: [companyResult.data].length > 0 ? "" : "Company not found." })
  }

  findContact = async ({taxCode, name}) => {
    if (!taxCode) return window.toast.error("Công ty này chưa có mã số thuế, vui lòng cập nhật lại thông tin công ty");
    const { contactStore } = this.props;
    let res = await contactStore.getContactList(taxCode);
    if (!!res.error) return window.toast.error("Error occurred, please try again " + JSON.stringify(res.error));
    this.setState({
      contactList: res.data, 
      message: res.data.length === 0 ? `${name} has no contact now` : `Display ${res.data.length} contacts of ${name}`
    });
  }
}

export default ContactList;



// WEBPACK FOOTER //
// ./src/views/Contacts/List.js